import axios from './index';
import DOMPurify from 'dompurify';

class FaqApi {
  static List = (data) => {
    let query = '?';

    query += `status=all&`;
    if (data.status) {
      query += `status=${data.status}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };
  // static FaqDelete = (data) => {
  //   let require = {
  //     id: data.id,
  //   };
  //   return axios.delete(`${base}/deletebyId`, require, {
  //     headers: { accessToken: data.token },
  //   });
  // };
  static FaqDelete = (data) => {
    const config = {
      headers: { accessToken: data.token },
      data: { id: data.id },
    };
    return axios.delete(`${base}/deletebyId`, config);
  };

  static Create = (data) => {
    let request = {
      question: DOMPurify.sanitize(data.question),
      answer: DOMPurify.sanitize(data.answer),
      display_order: data.displayOrder,
      language_code: data.language_code,
      is_active: data.isActive === 'true' ? true : false,
    };
    console.log(request);
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    let request = {};
    if (data.question) request.question = DOMPurify.sanitize(data.question);
    if (data.answer) request.answer = DOMPurify.sanitize(data.answer);
    if (data.isActive) request.is_active = data.isActive == true || data.isActive == 'true' ? true : false;
    if(data.displayOrder) request.display_order = data.displayOrder;
    if(data.language_code) request.language_code = data.language_code;
    return axios.put(`${base}/${data.faqId}`, request);
  };
}

let base = 'dashboard/faq';

export default FaqApi;
